import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Button from "./button"

import styles from "./buttons.module.scss"

const CourseButtons = props => (
  <StaticQuery
    query={graphql`
      {
        sanitySiteConfig {
          storeUrl
          demoForm
          hiddenField
        }
      }
    `}
    render={data => {
      const formUrl = `${data.sanitySiteConfig.demoForm}?${data.sanitySiteConfig.hiddenField}=${props.catId}`
      return (
        <div className={styles.buttons}>
          <Button
            to={formUrl}
            label="Request a free trial"
            buttonType="dark"
            type="formLinkButton"
          />
          <form action={data.sanitySiteConfig.storeUrl} method="POST">
            <input type="hidden" name="catalogid" value={props.catId} />
            <input
              type="hidden"
              name="return"
              value="https://leolearning.com/leo-grc-academy/"
            />
            <button type="submit" name="submit">
              <span>Buy now</span>
            </button>
          </form>
        </div>
      )
    }}
  />
)

export default CourseButtons
